import React, {useState} from 'react'



const Homepage = ()=>{


    return (
        <div className="Homepage">
            <h1>Welcome to my Pokemon Page!</h1>
            <p>The Pokemon Page will allow user to select Pokemon. The Show Page will show pokemon by type. Please Enjoy! Gotta Catch Em All!!</p>
        </div>
    )
}

export default Homepage